import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import ReactSVG from "react-svg";
import { Select, Input, Radio } from "@components/atoms";
import { checkoutMessages } from "@temp/intl";
import creaditCard from "src/images/payment/creditcard.svg";
import paypal from "src/images/payment/paypal.svg";
import unionpay from "src/images/payment/unionpay.svg";
import alipay from "src/images/payment/alipay.svg";
import wechatpay from "src/images/payment/wechatpay.svg"; // import { filterNotEmptyArrayItems } from "@utils/misc";
// import { Checkbox } from "@components/atoms/Checkbox/styles";
// import { AddressForm } from "../AddressForm";
// import { AddressGridSelector } from "../AddressGridSelector";

import * as S from "./styles";
import "./scss/index.scss";
/**
 * Address form used in checkout.
 */

var ShortInput = function ShortInput(props) {
  return React.createElement(S.ShortInput, null, React.createElement(Input, props));
};

var LongInput = function LongInput(props) {
  return React.createElement(S.LongInput, null, React.createElement(Input, props));
};

var ContrySelect = function ContrySelect(props) {
  return React.createElement(S.ContrySelect, null, React.createElement(Select, props));
};

var RadiosGroup = function RadiosGroup(props) {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  function afterClick(_x) {
    return _afterClick.apply(this, arguments);
  }

  function _afterClick() {
    _afterClick = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(value) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _afterClick.apply(this, arguments);
  }

  return props.values.map(function (i, idx) {
    return React.createElement(S.RadioWrapper, {
      key: idx
    }, React.createElement(Radio, {
      name: i.name,
      value: i.value,
      onClick: function onClick(e) {
        return i.onClick() || afterClick(e.currentTarget);
      },
      defaultChecked: i.defaultChecked
    }, React.createElement("span", {
      className: i.svgPath ? "payment_name" : ""
    }, i.text)), i.svgPath && React.createElement(ReactSVG, {
      path: i.svgPath,
      className: "svg"
    }));
  });
};

var CreateOrSelectAddr = function CreateOrSelectAddr(_ref) {
  var selectvalue = _ref.selectvalue,
      selectOptions = _ref.selectOptions,
      afterSelectChanged = _ref.afterSelectChanged,
      selectDefaultAddr = _ref.selectDefaultAddr,
      isDeliveryAddr = _ref.isDeliveryAddr,
      cityOptions = _ref.cityOptions,
      afterContrySelectChanged = _ref.afterContrySelectChanged,
      afterCitySelectChanged = _ref.afterCitySelectChanged,
      countryOptions = _ref.countryOptions;
  return React.createElement(S.DeliverWrapper, null, React.createElement(S.AddressSelect, null, React.createElement("p", {
    className: "title"
  }, isDeliveryAddr ? React.createElement(FormattedMessage, checkoutMessages.selectOrCreateDeliveryAddr) : React.createElement(FormattedMessage, checkoutMessages.selectOrCreateBillingAddr)), React.createElement(Select, {
    value: selectvalue,
    options: selectOptions,
    onChange: function onChange(e) {
      return afterSelectChanged(e);
    },
    defaultValue: selectDefaultAddr,
    placeholder: "Address Select"
  })), isDeliveryAddr && React.createElement(S.Title, {
    "data-test": "checkoutPageSubtitle"
  }, React.createElement(FormattedMessage, checkoutMessages.deliverAddress)), React.createElement(S.CreateNewAddress, null, React.createElement(ShortInput, {
    placeholder: "First Name",
    value: ""
  }), React.createElement(ShortInput, {
    placeholder: "Last Name",
    value: ""
  }), React.createElement(LongInput, {
    placeholder: "Address1",
    value: ""
  }), React.createElement(LongInput, {
    placeholder: "Address1",
    value: ""
  }), React.createElement(ShortInput, {
    placeholder: "Suburb",
    value: ""
  }), React.createElement(ShortInput, {
    placeholder: "Postal Code"
  }), React.createElement(ContrySelect, {
    value: "",
    options: cityOptions,
    onChange: function onChange(e) {
      return afterCitySelectChanged(e);
    },
    placeholder: "(City/Region)"
  }), React.createElement(ContrySelect, {
    value: "",
    options: countryOptions,
    onChange: function onChange(e) {
      return afterContrySelectChanged(e);
    },
    placeholder: "(Country)"
  }), React.createElement(ShortInput, {
    placeholder: "(Contact Number)",
    value: ""
  })));
};

var payment = [{
  value: 1,
  text: "Credit Card",
  name: "paymentWay",
  svgPath: creaditCard,
  defaultChecked: true
}, {
  value: 2,
  text: "PayPal",
  name: "paymentWay",
  svgPath: paypal
}, {
  value: 3,
  text: "UnionPay",
  name: "paymentWay",
  svgPath: unionpay
}, {
  value: 4,
  text: "AliPay",
  name: "paymentWay",
  svgPath: alipay
}, {
  value: 5,
  text: "WeChat Pay",
  name: "paymentWay",
  svgPath: wechatpay
}];
var addressArr = ["lastName", "firstName", "country", "city", "streetAddress1", "streetAddress2", "phone", "id", "isDefaultShippingAddress"];

var dealWithAddr = function dealWithAddr(arr) {
  return arr.map(function (i) {
    var _ref2;

    var address = i.address;
    var address1 = {}; // eslint-disable-next-line no-restricted-syntax

    for (var _i = 0, _addressArr = addressArr; _i < _addressArr.length; _i++) {
      var _i2 = _addressArr[_i];

      // eslint-disable-next-line no-restricted-syntax
      for (var _i3 = 0, _Object$entries = Object.entries(address); _i3 < _Object$entries.length; _i3++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (_i2 === key) {
          switch (_i2) {
            case "country":
              address1.country = (_ref2 = value) === null || _ref2 === void 0 ? void 0 : _ref2.country;
              break;

            default:
              address1[key] = value;
          }
        }
      }
    }

    return address1;
  });
};

var addrOptionShow = function addrOptionShow(arr) {
  return arr.map(function (i) {
    var value;
    var isDefaultShippingAddress;
    var label = []; // eslint-disable-next-line no-restricted-syntax

    for (var _i4 = 0, _Object$entries2 = Object.entries(i); _i4 < _Object$entries2.length; _i4++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i4], 2),
          key = _Object$entries2$_i[0],
          theValue = _Object$entries2$_i[1];

      switch (key) {
        case "id":
          value = theValue;
          break;

        case "isDefaultShippingAddress":
          isDefaultShippingAddress = theValue;
          break;

        default:
          label.push(theValue);
      }
    }

    label = label.toString();
    return {
      value: value,
      label: label,
      isDefaultShippingAddress: isDefaultShippingAddress
    };
  });
};

var defaultDeliveryAddr = function defaultDeliveryAddr(arr) {
  return arr.filter(function (i) {
    return i.isDefaultShippingAddress === true;
  })[0];
}; // const deliveryAddrShowing = (arr: any, id: string) => {
//   return arr.filter((i: any) => {
//     return i.id === id;
//   })[0];
// };


var CheckoutAddress = function CheckoutAddress(_ref3) {
  var checkoutShippingAddress = _ref3.checkoutShippingAddress,
      checkoutBillingAddress = _ref3.checkoutBillingAddress,
      _ref3$billingAsShippi = _ref3.billingAsShippingAddress,
      billingAsShippingAddress = _ref3$billingAsShippi === void 0 ? false : _ref3$billingAsShippi,
      email = _ref3.email,
      selectedUserShippingAddressId = _ref3.selectedUserShippingAddressId,
      selectedUserBillingAddressId = _ref3.selectedUserBillingAddressId,
      userAddresses = _ref3.userAddresses,
      countries = _ref3.countries,
      userId = _ref3.userId,
      shippingFormId = _ref3.shippingFormId,
      shippingFormRef = _ref3.shippingFormRef,
      billingFormId = _ref3.billingFormId,
      billingFormRef = _ref3.billingFormRef,
      shippingAddressRequired = _ref3.shippingAddressRequired,
      setShippingAddress = _ref3.setShippingAddress,
      setBillingAddress = _ref3.setBillingAddress,
      setBillingAsShippingAddress = _ref3.setBillingAsShippingAddress,
      shippingErrors = _ref3.shippingErrors,
      billingErrors = _ref3.billingErrors,
      newAddressFormId = _ref3.newAddressFormId;
  var intl = useIntl();
  var address = userAddresses;
  var waitforDealOptions = dealWithAddr(userAddresses);
  var addrOptions = addrOptionShow(waitforDealOptions);
  var defaultAddr = defaultDeliveryAddr(addrOptions);

  var _useState = useState(defaultAddr),
      _useState2 = _slicedToArray(_useState, 2),
      selectedAddr = _useState2[0],
      setSelectedAddr = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      createBillAddrShow = _useState4[0],
      setCreateBillAddrShow = _useState4[1];

  function afterAddressChange(_x2) {
    return _afterAddressChange.apply(this, arguments);
  }

  function _afterAddressChange() {
    _afterAddressChange = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(value) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return setSelectedAddr(value);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _afterAddressChange.apply(this, arguments);
  }

  return React.createElement(S.Wrapper, null, shippingAddressRequired && React.createElement(React.Fragment, null, React.createElement("section", null)), React.createElement("section", null, React.createElement(CreateOrSelectAddr, {
    selectvalue: selectedAddr,
    selectOptions: addrOptions,
    afterSelectChanged: function afterSelectChanged(e) {
      return afterAddressChange(e);
    },
    selectDefaultAddr: defaultAddr,
    isDeliveryAddr: true,
    cityOptions: address,
    afterCitySelectChanged: function afterCitySelectChanged(e) {
      return afterAddressChange(e);
    },
    countryOptions: countries,
    afterContrySelectChanged: function afterContrySelectChanged(e) {
      return afterAddressChange(e);
    }
  }), React.createElement(React.Fragment, null)), React.createElement("section", null, React.createElement(S.DeliverWrapper, null, React.createElement(S.BorderLineTitle, {
    "data-test": "checkoutPageSubtitle"
  }, React.createElement(FormattedMessage, checkoutMessages.billingAddress)), React.createElement(RadiosGroup, {
    values: [{
      value: "",
      name: "address",
      text: "Same as shipping address",
      defaultChecked: true,
      onClick: function onClick() {
        return setCreateBillAddrShow(false);
      }
    }, {
      value: "",
      name: "address",
      text: "Use a different billing address",
      onClick: function onClick() {
        return setCreateBillAddrShow(true);
      }
    }]
  }), createBillAddrShow && React.createElement(CreateOrSelectAddr, {
    selectvalue: selectedAddr,
    selectOptions: addrOptions,
    afterSelectChanged: function afterSelectChanged(e) {
      return afterAddressChange(e);
    },
    selectDefaultAddr: defaultAddr,
    isDeliveryAddr: false,
    cityOptions: address,
    afterCitySelectChanged: function afterCitySelectChanged(e) {
      return afterAddressChange(e);
    },
    countryOptions: countries,
    afterContrySelectChanged: function afterContrySelectChanged(e) {
      return afterAddressChange(e);
    }
  }))), React.createElement("section", null, React.createElement(S.DeliverWrapper, null, React.createElement(S.BorderLineTitle, {
    "data-test": "checkoutPageSubtitle"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Delivery Method",
    "id": "@next.components.organisms.CheckoutAddress.CheckoutAddress.4290494316"
  }, "id", "@next.components.organisms.CheckoutAddress.CheckoutAddress.4290494316"))), React.createElement(RadiosGroup, {
    values: [{
      value: "",
      text: "Standard Shipping",
      name: "deliveryMethod",
      defaultChecked: true
    }]
  }), React.createElement(S.DeliveryTextArea, null, React.createElement("textarea", {
    placeholder: "Delivery Instruction (if any)"
  })))), React.createElement("section", null, React.createElement(S.DeliverWrapper, null, React.createElement(S.BorderLineTitle, {
    "data-test": "checkoutPageSubtitle"
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.CheckoutAddress.CheckoutAddress.348821000",
    defaultMessage: "Payment Method"
  })), React.createElement("div", {
    className: "payment_method"
  }, React.createElement(RadiosGroup, {
    values: payment
  })), React.createElement(S.PaymentFooterTitle, null, "You will be forwarded to (CheckedWay) portal to proceed payment."))));
};

export { CheckoutAddress };